export default "__VITE_ASSET__BNRdMryi__"